import { render, staticRenderFns } from "./activeAuthorizations.vue?vue&type=template&id=2c3b5702"
import script from "./activeAuthorizations.js?vue&type=script&lang=js&external"
export * from "./activeAuthorizations.js?vue&type=script&lang=js&external"
import style0 from "./activeAuthorizations.vue?vue&type=style&index=0&id=2c3b5702&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports